// get the source of the visit - Organic, Paid, Social etc...
function getTrafficSource(referrer, url) {
	var trafficSource;
	referrer = referrer || "direct";
	var t = /utm_medium=([cp]pc|paid_social|paid|.*_ad.*)/i;
	if (url.match(/ndclid=/i)) trafficSource = "nextdoor_paid";
	else if (
		referrer.match(/doubleclick/i) ||
		url.match(/dclid=|wbraid=|gbraid=/i)
	)
		trafficSource = "google_paid";
	else if (referrer.match(/google/i) && !referrer.match(/mail\.google\.com/i)) {
		if (url.match(/gclid=/i)) return "google_paid";
		trafficSource =
			referrer.match(/googleadservices/i) ||
			url.match(/utm_(medium|source)=[cp]pc/i) ||
			url.match(/(matchtype|adposition)=/i)
				? "google_paid"
				: "google_organic";
	} else
		trafficSource = url.match(/gclid=/i)
			? referrer.match(/(\/|\.)youtube\./i) ||
			  url.match(/utm_source=.*youtube.*/i)
				? "youtube_paid"
				: url.match(/msclkid=/i)
				? "bing_paid"
				: "google_paid"
			: url.match(/msclkid=/i)
			? referrer.match(/(\/|\.)duckduckgo\./i) ||
			  url.match(/utm_source=.*duckduckgo.*/i)
				? "duckduckgo_paid"
				: "bing_paid"
			: referrer.match(/(\/|\.)bing\./i) || url.match(/utm_source=.*bing.*/i)
			? url.match(t) || url.match(/msclkid=/i)
				? "bing_paid"
				: "bing_organic"
			: referrer.match(/msn\.com/i)
			? "bing_paid"
			: referrer.match(/yahoo/i) && !referrer.match(/mail\.yahoo\.com/i)
			? url.match(t)
				? "yahoo_paid"
				: "yahoo_organic"
			: url.match(/fb_ad_id=/i)
			? referrer.match(/(\/|\.)instagram\./i) ||
			  url.match(/utm_source=.*instagram.*/i)
				? "instagram_paid"
				: "facebook_paid"
			: url.match(/(fbclid=)/i) && referrer.match(/(\/|\.)instagram\./i)
			? url.match(t)
				? "instagram_paid"
				: "instagram_organic"
			: referrer.match(/(\/|\.)facebook\./i) ||
			  url.match(/(fbclid=|utm_source=.*facebook.*)/i)
			? url.match(t)
				? "facebook_paid"
				: "facebook_organic"
			: referrer.match(/(\/|\.)instagram\./i) ||
			  url.match(/utm_source=.*instagram.*/i)
			? url.match(t)
				? "instagram_paid"
				: "instagram_organic"
			: referrer.match(/(\/|\.)duckduckgo\./i) ||
			  url.match(/utm_source=.*duckduckgo.*/i)
			? url.match(t)
				? "duckduckgo_paid"
				: "duckduckgo_organic"
			: referrer.match(/(\/|\.)nextdoor\./i) ||
			  url.match(/utm_source=.*nextdoor.*/i)
			? url.match(t)
				? "nextdoor_paid"
				: "nextdoor_organic"
			: referrer.match(/(\/|\.)linkedin\./i) ||
			  url.match(/utm_source=.*linkedin.*/i)
			? url.match(t)
				? "linkedin_paid"
				: "linkedin_organic"
			: referrer.match(/(\/|\.)twitter\./i) ||
			  url.match(/utm_source=.*twitter.*/i)
			? url.match(t)
				? "twitter_paid"
				: "twitter_organic"
			: referrer.match(/(\/|\.)pinterest\./i) ||
			  url.match(/utm_source=.*pinterest.*/i)
			? url.match(t)
				? "pinterest_paid"
				: "pinterest_organic"
			: referrer.match(/(\/|\.)spotify\./i) ||
			  url.match(/utm_source=.*spotify.*/i)
			? url.match(t)
				? "spotify_paid"
				: "spotify_organic"
			: referrer.match(/(\/|\.)yelp\./i) || url.match(/utm_source=.*yelp.*/i)
			? url.match(t) ||
			  url.match(/utm_(medium|source|campaign)=yelp_ad/i) ||
			  url.match(/campaign_code=yelp_ad/i)
				? "yelp_paid"
				: "yelp_organic"
			: referrer.match(/(\/|\.)youtube\./i) ||
			  url.match(/utm_source=.*youtube.*/i)
			? url.match(t)
				? "youtube_paid"
				: "youtube_organic"
			: "direct" === referrer
			? url.match(t) && url.match(/utm_source=.*google.*/i)
				? "google_paid"
				: "direct"
			: getReferrerDomain(referrer);
	return trafficSource;
}

function getReferrerDomain(referrer) {
	var domain = referrer.split("/")[2],
		domainParts = domain.split(".");
	return domainParts.length > 2
		? domainParts[domainParts.length - 2] +
				"." +
				domainParts[domainParts.length - 1]
		: domain;
}
module.exports = getTrafficSource;
